export { ModalConfirmation } from './ModalConfirmation';
export { ModalConfirmationDrugOff } from './ModalConfirmationDrugOff';
//It appears when you want to initiate an efficient purchase but need two or more credentials at the point of sale.
export { ModalDontHaveCredentials } from './ModalDontHaveCredentials';
export { ModalMinimunAmount } from './ModalMinimunAmount';
export { ModalIncompleteDocs } from './ModalIncompleteDocs';
export { ModalYoutube } from './ModalYoutube';